import { useMedplumProfile } from '@medplum/react'
import type { JSX } from 'react'
import { Navigate } from 'react-router'
import { MealTicketPrinter } from '#src/MealTicketPrinter.tsx'

export function App(): JSX.Element {
  const profile = useMedplumProfile()

  if (!profile) {
    return <Navigate to="/signin" replace />
  }

  return <MealTicketPrinter />
}
